import { Suspense } from 'react'
import { Switch, Redirect } from 'react-router-dom'
import { common } from '@ocean/ui'
import { PrivateRoute } from 'routing/components'
import homeRoutes from 'modules/Home/routing/routes'
import InstructorRouting from './InstructorRouting'
import StudentRouting from './StudentRouting'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

const SimulatorTrainingRouting = () => {
  return (
    <Suspense fallback={<RouteChangeProgress />}>
      <Switch>
        <PrivateRoute path={routes.instructor} component={InstructorRouting} />
        <PrivateRoute path={routes.student} component={StudentRouting} />
        <Redirect path='*' to={homeRoutes.root} />
      </Switch>
    </Suspense>
  )
}

export default SimulatorTrainingRouting
